import {
  APIBusinessCriticalFieldsResponse,
  PersistedEntityGroupShape,
} from '@ardoq/api-types';
import { crudApi, fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';

const PRIORITY_VIEWPOINTS_ENTITY_GROUP_NAME = 'Priority Viewpoints';

const BUSINESS_CRITICAL_FIELDS_ENTITY_GROUP_NAME = 'Business Critical Fields';

const SYSTEM_MANAGED_ENTITY_GROUP_NAMES: ReadonlySet<string> = new Set([
  BUSINESS_CRITICAL_FIELDS_ENTITY_GROUP_NAME,
  PRIORITY_VIEWPOINTS_ENTITY_GROUP_NAME,
]);

export const isSystemManagedEntityGroupName = (name: string): boolean =>
  SYSTEM_MANAGED_ENTITY_GROUP_NAMES.has(name);

const fetchBusinessCriticalFields = async () => {
  const request = new Request(`/api/entity-group/business-critical-fields`);
  return fetchJson<APIBusinessCriticalFieldsResponse>(request);
};

const updateBusinessCriticalFields = async (
  fieldIds: string[],
  componentTypeIds: string[]
): ApiResponse<APIBusinessCriticalFieldsResponse> => {
  const request = new Request(
    `/api/entity-group/business-critical-fields`,
    toRequestOptions(Method.PUT, {
      fieldIds,
      componentTypeIds,
    })
  );
  return fetchJson<APIBusinessCriticalFieldsResponse>(request);
};

export const entityGroupApi = {
  ...crudApi<PersistedEntityGroupShape>('entity-group'),
  fetchBusinessCriticalFields,
  updateBusinessCriticalFields,
};
